<app-spinner [isLoading]="isLoadingSpinner"></app-spinner>

<div class="qb-shell" *ngIf="!isLoadingSpinner">
  <header class="brand-topbar">
    <span class="brand-mark" aria-hidden="true">P</span>
    <span class="admin-brand-name">Paierly</span>
  </header>

  <div class="admin-content">
    <div class="page-width-form">
      <div class="page-header">
        <div>
          <h1 class="page-header-title">QuickBooks connection</h1>
          <p class="page-header-subtitle">
            Paierly reads the invoices you already have in QuickBooks and writes
            payments back automatically. One connection, nothing else to
            maintain.
          </p>
        </div>
      </div>

      <div class="card">
        <div class="card-body">
          <div *ngIf="!isConnected" class="qb-connect">
            <div class="qb-connect-header">
              <img
                src="assets/img/quickbooks-seeklogo.svg"
                alt=""
                class="qb-logo"
                aria-hidden="true"
              />
              <div>
                <h3>QuickBooks Online</h3>
                <span class="badge badge-neutral">
                  <svg class="icon" viewBox="0 0 24 24" aria-hidden="true">
                    <circle cx="12" cy="12" r="9" />
                    <line x1="9" y1="12" x2="15" y2="12" />
                  </svg>
                  Not connected
                </span>
              </div>
            </div>

            <div class="qb-permissions">
              <p class="text-overline">What Paierly will be allowed to do</p>
              <ul class="qb-permissions-list">
                <li>
                  <svg class="icon icon-sm" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M20 6L9 17l-5-5" />
                  </svg>
                  <span>Read your invoices and customer names</span>
                </li>
                <li>
                  <svg class="icon icon-sm" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M20 6L9 17l-5-5" />
                  </svg>
                  <span>Record payments against those invoices</span>
                </li>
                <li>
                  <svg class="icon icon-sm" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M20 6L9 17l-5-5" />
                  </svg>
                  <span>No access to payroll, banking or vendor data</span>
                </li>
              </ul>
            </div>

            <a class="qb-connect-cta" href="#" (click)="connectToQuickBooks($event)">
              <img
                src="assets/img/C2QB_green_btn_med_default.png"
                alt="Connect to QuickBooks"
              />
            </a>
            <p class="text-caption qb-connect-note">
              You'll be taken to Intuit to approve access. You can disconnect at
              any time.
            </p>
          </div>

          <div *ngIf="isConnected" class="qb-connected">
            <div class="qb-connected-header">
              <span class="merchant-initials" aria-hidden="true">
                <svg class="icon" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M20 6L9 17l-5-5" />
                </svg>
              </span>
              <div>
                <h3>Welcome, {{ name }}</h3>
                <span class="badge badge-success">
                  <svg class="icon" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M20 6L9 17l-5-5" />
                  </svg>
                  Connected
                </span>
              </div>
            </div>
            <p>
              You are connected to QuickBooks. You can now check your invoices
              and generate your payment links.
            </p>
            <button type="button" class="btn btn-danger" (click)="disconnectFromQuickBooks()">
              Disconnect from QuickBooks
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
